import { Box, Button, Link, Text } from "@chakra-ui/react"
import { PublicationBlockLinkPublic } from "../../client"

const LinkBlock = ({ data }: { data: PublicationBlockLinkPublic }) => {
    return (
        <Box my={10}>
            {data.description &&
                <Text mb={4}>{data.description}</Text>
            }
            <Link href={data.url} textDecoration="none" target="_blank">
                <Button variant="primary">{data.button_label}</Button>
            </Link>
        </Box>
    )
}

export default LinkBlock